import ColorString from 'color-string';

export const RGBA_SUPPORT_VERSION = '11.8.0';

/**
 * @this {{compareVer: (version: string) => 0|-1|1}}
 * @description 颜色字符串标准化，app 端安卓收到缩写颜色时会闪退
 * @param {String} colorStr
 */
export function resolveColorString(colorStr) {
    const result = ColorString.get(colorStr);

    if (result) {
        // 不支持 rgba 的 强行切成 7 位字符
        const raw = ColorString.to.hex(result.value);
        // 如果不是 孕育 或者 妈妈轻聊就直接返回
        if (!(this.UA.pregnancyhelper || this.UA.mmq)) {
            return raw;
        }
        if (this && typeof this.compareVer && this.compareVer(RGBA_SUPPORT_VERSION) >= 0) {
            return raw;
        } else {
            return raw.slice(0, 7);
        }
    } else {
        throw new Error('非法的颜色字符！');
    }
}
